import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, FormGroup} from '@mui/material';

import CheckboxGroup2 from '../../components/CheckboxGroup2';
import ScenarioList2 from "../../components/SectionList2";

import FASiteOptionsDataHelper, {
  allNumeric,
  allDates,
  sortedLikeDates
} from '../../data/FallowARM/FASiteOptionsDataHelper';

import configHelper from '../../data/configHelper';
import FAScenarioOptionsDataHelper from "../../data/FallowARM/FAScenarioOptionsDataHelper";

import pageStyles from "../ScenarioSelectionStep.module.scss";
import sharedStyles from "../sharedPageStyles.module.scss";
import LoadingComponent from '../../components/LoadingComponent';

class FAScenarioSelectionStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scenarioOptions: [],
      siteScenarioSelections: {},
      loadingState: 'loading',
      error: {},
    };
  }

  onScenarioOptionSelection = (event, value) => {
    // process update event
    let updateIndex = JSON.parse(event.target.parentElement.dataset.updateIndex);
    let simField = updateIndex.simField;
    let updateValue = isNaN(event.target.value) ? event.target.value : Number(event.target.value);
    let update = value; // has this been checked or not?

    this.updateSelection(simField, updateValue, update);
  }

  excludeOption = (fieldKey, removePAWCFromList = false) => {
    const excludeFields = ['soil', 'soilname', 'soil_type']
    if (!removePAWCFromList) {
      excludeFields.push('pawc');
    }
    const excludeIndex = excludeFields.indexOf(fieldKey.toLowerCase());
    return excludeIndex === -1 ? false : true;
  }

  loadScenarioOptions = () => {

    // Need these before we drop into the FAScenarioOptionsDataHelper.scenarioOptionsFromAPI promise.
    const selectUpdateFunc = this.updateSelection;
    const autoSelect = this.props.autoSelectSingleEntry;

    // this is where we would load scenario options in for a site provided.
    // we'd also want to make sure we set a "loading" flag in state here in case we wanted to show a loading element.
    let self = this;
    FAScenarioOptionsDataHelper.scenarioOptionsFromAPI(this.props.Site)
      .then((response) => {
        // console.log('API Response ', response);
        const apiOptions = response.data.options;
        // self.state.scenarioOptions = response.data.options;
        let finalOptions;
        if (self.props.SelectedSoil.pawc) {
          // self.state.scenarioOptions = self.state.scenarioOptions.filter(factor => !excludeField(factor.key))
          finalOptions = apiOptions.filter(factor => !this.excludeOption(factor.key));
        }
        // let changedScenarioOptions = self.state.scenarioOptions;
        self.setState({
          //scenarioOptions: changedScenarioOptions,
          scenarioOptions: finalOptions,
          loadingState: 'success',
        });

        // Pre-select options with only one value.
        if (autoSelect) {
          finalOptions.forEach((option, index) => {
            if (option.values.length === 1) {
              let updateValue = isNaN(option.values[0]) ? option.values[0] : Number(option.values[0]);
              const optionKey = index.toString();
              selectUpdateFunc(optionKey, option.key, updateValue, true);  
            }
          })
        }
      })
      .catch(function(error) {
        console.log(error);
        self.setState({
          loadingState: 'error',
          error: error,
        });
      })
  };

  updateSelection = (simField, updateValue, update) => {
    // if this option has not been checked before, we need to ensure that an array is available
    // to insert the relevant value into.
    let siteScenarioSelections = this.state.siteScenarioSelections;

    if (!siteScenarioSelections[simField]) {
      siteScenarioSelections[simField] = [];
    }

    if (update) {
      siteScenarioSelections[simField].push(updateValue);
    } else {
      // we need to remove from the array
      // we can't clear the array, as there may be multiple options selected for this simField
      let index = siteScenarioSelections[simField].indexOf(updateValue);
      siteScenarioSelections[simField].splice(index, 1);
    }

    this.setState({siteScenarioSelections});
  };

  isFilterOnly = (factorKey) => {
    let filterOnly = false;
    const optionDetails = this.state.scenarioOptions.find((scenario) => scenario.key === factorKey);
    if (optionDetails) {
      filterOnly = optionDetails.filterOnly;
    }

    return filterOnly;
  }

  isScenarioOptionSelected = (simField, option) => {
    let selectedOptions = this.state.siteScenarioSelections[simField];
    if (selectedOptions === undefined) {
      return false;
    } else if (selectedOptions.indexOf(option) !== -1) {
      return true;
    }
    return false;
  }

  isValidScenarioPresent = () => {
    let result = true;
    // Set availableSimFactors to the factors that are not filteronly.
    // These are the ones that need to be checked.
    let availableSimFactors = this.state.scenarioOptions.filter((s) => !s.filterOnly);
    let selectedSimFactors = this.state.siteScenarioSelections;

    // The counts are fine but do they each contain data?
    availableSimFactors.forEach(factor => {
      if (selectedSimFactors.hasOwnProperty(factor.key)) {
        if (selectedSimFactors[factor.key].length === 0) {
          result = false;
        }
      }
    });

    // This user must select at least one of these.
    const filterFactors = this.state.scenarioOptions.filter((s) => s.filterOnly);
    filterFactors.forEach(factor => {
      if (selectedSimFactors.hasOwnProperty(factor.key)) {
        if (selectedSimFactors[factor.key].length === 0) {
          result = false;
        }
      } else {
        result = false;
      } 
    });

    return result;
  }

  isScenarioLimitReached = () => {
    return this.calculateNumberOfScenariosToGenerate() + this.props.scenarios.length > configHelper.MAX_SCENARIOS;
  }

  calculateNumberOfScenariosToGenerate = () => {
    let selectedSimFactors = this.state.siteScenarioSelections;
    let numberOfScenarios = 0;
    
    Object.keys(selectedSimFactors).forEach((factor) => {
      // Need to check if the factor is filterOnly. These do not contribute
      // to additional scenarios. The data is simply filtered on these values.    
      const filterOnly = this.isFilterOnly(factor);

      if (!filterOnly) {
        let scenarioModifier = selectedSimFactors[factor].length;
        if (numberOfScenarios === 0) {
          numberOfScenarios += scenarioModifier;
        } else {
          // the number of scenarios grows exponentially
          // based on the number of scenario options chosen
          numberOfScenarios = numberOfScenarios * scenarioModifier;
        }
      }
    });
    return numberOfScenarios;
  }

  onScenarioAdd = () => {
    // bubble up this event to ScenarioBuilder
    // all scenarios will be calculated and added at that level
    console.log('Selected Scenarios', this.state.siteScenarioSelections);
    let selectedSimFactors = this.state.siteScenarioSelections;
    this.props.handleScenarioAddition(selectedSimFactors);
  }

  haveScenarioOptions = () => {
    let result = false;
    if (this.state.scenarioOptions !== undefined) {
      if (this.state.scenarioOptions.length > 0) {
        result = true;
      }
    }
    return result;
  }

  componentDidMount() {
    this.loadScenarioOptions(this.props.Site);
  }

  sortDisplayValues = (values) => {
    let sortedValues;
    if (allDates(values)) {
      sortedValues = sortedLikeDates(values);
    } else if (allNumeric(values)) {
      values.sort( function( a , b){
        if(a > b) return 1;
        if(a < b) return -1;
        return 0;
      });
      sortedValues = [...values];
    } else {
      sortedValues = [...values];
    }

    return sortedValues;
  }

  render() {
    return (
      <>
        <Box className={sharedStyles.scenarioStepSection}>
          <div>
            <div className={pageStyles.creationContainer}>
              <div className={pageStyles.creationLeft}>
                <Typography variant="h6">
                  Scenario Creation
                </Typography>
                <Typography variant="body1" gutterBottom>
                  After adding at least one scenario, a list of scenarios will display
                  at the bottom of the page. You can review this list before submitting
                  for further processing.
                </Typography>
              </div>
            </div>

            {this.state.loadingState === 'error' && 
              <LoadingComponent fullwidth={true} state='error' error={this.state.error} />
            }
            {this.state.loadingState === 'loading' &&
              <LoadingComponent fullwidth={true} state='loading' /> 
            }
            <FormGroup row={true} sx={{ marginTop: "0.5em" }}>
              {this.state.scenarioOptions !== undefined &&
                <div>
                  {this.state.scenarioOptions.map((factor) => {
                    const sortedValues = this.sortDisplayValues(factor.values);
                    return (
                      <CheckboxGroup2
                        key={factor.label}
                        label={factor.label}
                        options={sortedValues}
                        horizontal={true}
                        labelStyling={{ margin: "1em", marginLeft: "0em" }}
                        isChecked={(option) => {return this.isScenarioOptionSelected(factor.key, option)}}
                        onChange={this.onScenarioOptionSelection}
                        updateIndex={JSON.stringify({
                          "site": this.props.Site,
                          "simField": factor.key
                        })}
                      />
                    );
                  })}

                  <div className={pageStyles.formBottomRow}>
                    <Typography>
                      This configuration will add {this.calculateNumberOfScenariosToGenerate()} scenarios.
                    </Typography>

                    {this.isScenarioLimitReached() &&
                      <Typography variant="caption">
                        Adding this many scenarios would exceed the scenario limit.
                      </Typography>
                    }

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={!this.isValidScenarioPresent() || this.isScenarioLimitReached()}
                      onClick={() => this.onScenarioAdd()}
                    >
                      Add Scenario/s
                    </Button>
                  </div>

                </div> 
              }
            </FormGroup>
            <div key={this.props.Site}>
              <Box
                overflow="auto"
                sx={{ border: "1px solid", borderRadius: "15px", flexGrow: 1, marginTop: "0.5em", padding: "1em" }}
              >
                <Typography variant="h5">
                  {this.props.Site}
                </Typography>
                {this.props.SelectedSoil &&
                  <Typography variant="caption">
                    Soil Type: {this.props.SelectedSoil.description}
                  </Typography>
                }

                {this.props.scenarios.length > 0 && 
                  <ScenarioList2
                    scenarios={this.props.scenarios}
                    handleScenarioDeletion={this.props.handleScenarioDeletion} />
                }

              </Box>
            </div>
          </div>
          <LoadingComponent/>
        </Box>
      </>
    )
  }
}

FAScenarioSelectionStep.propTypes = {
  Site: PropTypes.string.isRequired,
  SiteId: PropTypes.number.isRequired,
  SelectedSoil: PropTypes.object.isRequired,
  handleScenarioAddition: PropTypes.func,
  handleScenarioDeletion: PropTypes.func,
  scenarios: PropTypes.array,
  autoSelectSingleEntry: PropTypes.bool,
};

FAScenarioSelectionStep.defaultProps = {
  autoSelectSingleEntry: true,
};

export default FAScenarioSelectionStep;
